import React, { useEffect, useContext, useState } from 'react';
import { string } from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import classNames from 'classnames/bind';
import { useHelmet, LinkTag } from '@thd-nucleus/thd-helmet';
import styles from './SponsoredNonEndemic.scss';
import { triggerNewRelic } from '../../utils/helpers';
import { newRelicConstants } from '../../constants/newRelicConstants';
import { addScriptTag,
  getGAMConfigData,
  getExperienceStyledDefaultBanner,
  GAMConstants } from '../../utils/nonEndemicHelpers';
import { Placeholder } from '~/@thd-olt-component-react/core-ui/dist/core-ui';
import { DIMENSIONS } from '../../constants/dimensions';

const hoistedImgFunction = ({ data }) => {
  const { thdDefaultBannerInfo } = data;
  return [
    new LinkTag({
      rel: 'preload',
      as: 'image',
      href: thdDefaultBannerInfo.imgSrc,
      id: 'spBannerPreloadLink',
    }),
  ];
};

const SponsoredNonEndemic = ({ experienceSlug }) => {
  const cx = classNames.bind(styles);
  const experienceContext = useContext(ExperienceContext);
  const channel = experienceContext.channel === 'desktop' ? 'desktop' : 'mobile';
  const gamConfigData = getGAMConfigData({ experienceSlug, channel });
  const thdDefaultBannerInfo = getExperienceStyledDefaultBanner(experienceContext, gamConfigData);
  const [hasGoogleTag, setHasGoogleTag] = useState(false);

  const data = {
    thdDefaultBannerInfo,
  };

  useHelmet('preloadNonEndmicBanner', { data }, hoistedImgFunction);

  const nonEndemicBanner = () => {

    addScriptTag('https://securepubads.g.doubleclick.net/tag/js/gpt.js');
    window.googletag = window.googletag || { cmd: [] };
    triggerNewRelic(newRelicConstants.NON_ENDEMIC_BANNER, newRelicConstants.LOAD);

    /* istanbul ignore next */
    window.googletag.cmd.push(function () {
      window.googletag
        .defineSlot(
          gamConfigData.adUnitPath,
          gamConfigData.adAssetDimensions,
          'non-endemic-banner',
        )
        .addService(window.googletag.pubads());
      window.googletag.enableServices();
      window.googletag.pubads().setCentering(true);

      window.googletag.cmd.push(function () {
        window.googletag.display('non-endemic-banner');
      });
    });

    setHasGoogleTag(true);
  };
  useEffect(
    () => {
      if (!window.googletag?.cmd) {
        nonEndemicBanner();
      } else {
        setHasGoogleTag(true);
      }
    },
    []
  );

  const placeholderHeightHandler = () => {
    switch (experienceSlug) {
    case GAMConstants.MOVE:
      return channel === 'mobile'
        ? DIMENSIONS.GAM.MOVE.HEIGHT.MOBILE
        : DIMENSIONS.GAM.MOVE.HEIGHT.DESKTOP;
    case GAMConstants.ALP:
    case GAMConstants.CONTENT:
      return channel === 'mobile'
        ? DIMENSIONS.GAM.DIY.HEIGHT.MOBILE
        : DIMENSIONS.GAM.DIY.HEIGHT.DESKTOP;
    default:
      return DIMENSIONS.GAM.DEFAULT.HEIGHT;
    }
  };

  return (
    <>
      {
        !hasGoogleTag
      && (
        <Placeholder
          type="rect"
          height={`${placeholderHeightHandler()}px`}
          width="100%"
        />
      )
      }
      {
        hasGoogleTag
        && (
          <div
            id="non-endemic-banner-container"
            className={cx('non-endemic-banner-container ' + experienceSlug.toLowerCase() + '-' + channel)}
            style={thdDefaultBannerInfo.containerStyle}
          >
            <div
              className={cx('non-endemic-banner')}
              id="non-endemic-banner"
              data-testid="non-endemic-banner"
            >
              <a href={thdDefaultBannerInfo.href}>
                <div
                  style={thdDefaultBannerInfo.bgCss}
                />
              </a>
            </div>
          </div>
        )
      }
    </>
  );
};

SponsoredNonEndemic.propTypes = {
  experienceSlug: string
};

// Including all experience names, comment out for easy testing
SponsoredNonEndemic.defaultProps = {
//   experienceSlug: 'Default'
  experienceSlug: 'move'

};

export { SponsoredNonEndemic };
